import { InjectionToken } from '@angular/core';

export interface NotificationLike {
  permission: NotificationPermission;
  requestPermission(): Promise<NotificationPermission>;
}

class MockNotificationForMobileDevices implements NotificationLike {
  permission: NotificationPermission = 'denied';

  requestPermission(): Promise<NotificationPermission> {
    return Promise.resolve('denied');
  }
}

export const NOTIFICATION = new InjectionToken<NotificationLike>('NOTIFICATION_TOKEN', {
  providedIn: 'root',
  factory: () => {
    return typeof window !== 'undefined' && 'Notification' in window
      ? Notification
      : new MockNotificationForMobileDevices();
  },
});
